function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { ConsoleLogger } from './logger/Console';
import { asyncTimeout } from './util';
import { correctCidDrift } from './patchCids';
const READY_CHECK_TIMEOUT_MILLIS = 3000;
const defaultAnalyticsClientConfiguration = {
    providers: [],
    logger: ConsoleLogger
};
const STYLES = {
    background: 'green',
    color: 'white',
    display: 'block'
};
const STYLES_STRING = Object.keys(STYLES).map((key)=>`${key}: ${STYLES[key]}; `).join('');
export var AnalyticsClientMode;
(function(AnalyticsClientMode) {
    AnalyticsClientMode[AnalyticsClientMode["BUFFERING"] = 0] = "BUFFERING";
    AnalyticsClientMode[AnalyticsClientMode["PASSTHROUGH"] = 1] = "PASSTHROUGH";
    AnalyticsClientMode[AnalyticsClientMode["FAILED"] = 2] = "FAILED";
})(AnalyticsClientMode || (AnalyticsClientMode = {}));
export class Client {
    initialize() {
        var _this = this;
        return _async_to_generator(function*() {
            _this.config.logger.info('%c [Analytics] Initializing analytics...', STYLES_STRING);
            if (_this.config.patchMismatchedCids) {
                _this.correctCidDrift();
            }
            try {
                yield _this.ready();
                _this.config.logger.info('%c [Analytics] All analytics providers successfully loaded', STYLES_STRING);
                _this.config.logger.info(' [Analytics]', _this.config);
                _this.mode = 1;
                _this.flushBuffer();
            } catch (err) {
                _this.mode = 2;
                _this.config.logger.error(` [Analytics] Could not ensure all analytics providers were ready within ${READY_CHECK_TIMEOUT_MILLIS}ms`);
                _this.config.logger.info(_this.config);
            }
        })();
    }
    trackPage(page) {
        var _this = this;
        return _async_to_generator(function*() {
            _this.track('page', page, (provider, data)=>provider.trackPage(data));
        })();
    }
    trackEvent(event) {
        var _this = this;
        return _async_to_generator(function*() {
            _this.track('event', event, (provider, data)=>provider.trackEvent(data));
        })();
    }
    trackVitals(vitals) {
        var _this = this;
        return _async_to_generator(function*() {
            _this.track('vitals', vitals, (provider, data)=>provider.trackVitals(data));
        })();
    }
    setExperimentTreatment(treatment) {
        var _this = this;
        return _async_to_generator(function*() {
            _this.track('experiment', treatment, (provider, data)=>provider.setExperimentTreatment(data));
        })();
    }
    correctCidDrift() {
        if (this.config.patchMismatchedCids) {
            const result = correctCidDrift();
            if (result.corrected) {
                this.config.logger.info('%c [Analytics] CID drift corrected', STYLES_STRING);
                this.trackEvent({
                    category: 'Page',
                    action: 'cid_drift_corrected',
                    label: `{"old_lsid": "${result.oldLsid}", "old_cid": "${result.oldCid}"}`
                });
            }
        }
    }
    ready() {
        var _this = this;
        return _async_to_generator(function*() {
            yield asyncTimeout(Promise.all(_this.config.providers.map((p)=>p.ready())), READY_CHECK_TIMEOUT_MILLIS);
        })();
    }
    flushBuffer() {
        this.config.logger.info('%c [Analytics] Flushing buffer', STYLES_STRING);
        this.buffer.forEach((entry)=>{
            switch(entry.entryType){
                case 'page':
                    this.trackPage(entry.data);
                    break;
                case 'event':
                    this.trackEvent(entry.data);
                    break;
                case 'vitals':
                    this.trackVitals(entry.data);
                    break;
                case 'experiment':
                    this.setExperimentTreatment(entry.data);
                    break;
                default:
            }
        });
        this.buffer = [];
    }
    track(entryType, data, onTrack) {
        switch(this.mode){
            case 1:
                this.config.providers.forEach((provider)=>onTrack(provider, data));
                break;
            case 0:
                this.buffer.push({
                    entryType,
                    data
                });
                break;
            default:
                break;
        }
    }
    constructor(config){
        _define_property(this, "config", defaultAnalyticsClientConfiguration);
        _define_property(this, "buffer", []);
        _define_property(this, "mode", 0);
        this.config = config;
    }
}

//# sourceMappingURL=Client.js.map